import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { PORTFOLIO_PROJECTS } from "./projects"

function exploreLabel(id: string): string {
  if (id === "gamedna") return "EXPLORE GAMEDNA"
  if (id === "black-velvet-records") return "EXPLORE BLACK VELVET"
  if (id === "bvr-flow") return "EXPLORE BVR FLOW"
  if (id === "bvr-volt") return "EXPLORE BVR VOLT"
  if (id === "ai-mastering") return "EXPLORE AI MASTERING"
  return "EXPLORE"
}

export function SelectedWork() {
  return (
    <Box
      id="selected-work"
      component="section"
      sx={{
        position: "relative",
        zIndex: 2,
        scrollMarginTop: 24,
        px: { xs: 2, md: 4 },
        pt: { xs: 10, md: 14 },
        pb: { xs: 4, md: 6 },
        maxWidth: 1100,
        width: "100%",
        mx: "auto",
        pointerEvents: "auto",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          letterSpacing: "0.28em",
          fontSize: "calc(0.72rem + 2px)",
          fontWeight: 700,
          color: "rgba(120,230,255,0.9)",
          mb: 1,
          textAlign: "center",
        }}
      >
        SELECTED WORK
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Space Grotesk", "Sora", system-ui, sans-serif',
          fontWeight: 600,
          letterSpacing: "-0.03em",
          fontSize: { xs: "2.1rem", md: "3.2rem" },
          textAlign: "center",
          lineHeight: 1.05,
          mb: 1.25,
        }}
      >
        ENGINEERING. CREATIVITY. TECHNOLOGY.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          color: "rgba(200,215,245,0.72)",
          maxWidth: 560,
          mx: "auto",
          mb: 4,
          fontSize: "calc(0.95rem + 2px)",
        }}
      >
        GameDNA sports desks, Black Velvet Records, BVR FLOW, BVR VOLT, and AI Mastering on our own DSP. Real product interfaces.
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(2, minmax(0, 1fr))",
          },
          gap: 2,
          minWidth: 0,
        }}
      >
        {PORTFOLIO_PROJECTS.map((p) => (
          <Box
            key={p.id}
            sx={{
              border: "1px solid rgba(140,190,255,0.28)",
              bgcolor: "rgba(4,8,18,0.82)",
              backdropFilter: "blur(10px)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              minHeight: "100%",
            }}
          >
            <Box
              component="img"
              src={p.primary.src}
              alt={p.primary.alt}
              loading="lazy"
              sx={{
                width: "100%",
                aspectRatio: p.primary.frame === "phone" ? "9 / 16" : "16 / 10",
                maxHeight: p.primary.frame === "phone" ? 420 : "none",
                objectFit: p.primary.frame === "phone" ? "contain" : "cover",
                objectPosition: "top center",
                display: "block",
                bgcolor: p.primary.frame === "phone" ? "#050c16" : "transparent",
                borderBottom: "1px solid rgba(140,190,255,0.2)",
              }}
            />
            <Stack spacing={1.25} sx={{ p: 2, flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  letterSpacing: "0.18em",
                  fontSize: "calc(0.62rem + 2px)",
                  fontWeight: 700,
                  color: "rgba(120,230,255,0.85)",
                }}
              >
                {p.eyebrow}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Space Grotesk", "Sora", system-ui, sans-serif',
                  fontWeight: 600,
                  letterSpacing: "-0.02em",
                  fontSize: "calc(1.25rem + 2px)",
                  lineHeight: 1.15,
                }}
              >
                {p.title}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(210,225,255,0.78)",
                  fontSize: "calc(0.88rem + 2px)",
                  flex: 1,
                }}
              >
                {p.description}
              </Typography>
              <Button
                component={Link}
                href={`#${p.anchor}`}
                sx={{
                  alignSelf: "flex-start",
                  letterSpacing: "0.14em",
                  fontSize: "calc(0.68rem + 2px)",
                  fontWeight: 700,
                  color: "rgba(120,230,255,0.95)",
                  textDecoration: "none",
                  px: 0,
                  minWidth: 0,
                }}
              >
                {exploreLabel(p.id)}
              </Button>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
